import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';

const BlogList = ({ title , children , noArticlesLabel ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: "blog-list"
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        className: "blog-list__title"
    }, title), children ? /*#__PURE__*/ React.createElement("div", {
        className: "blog-list__wrapper"
    }, children) : /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: "blog-list__message"
    }, noArticlesLabel))
;

export { BlogList as default };
//# sourceMappingURL=BlogList.js.map
